<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Distance Prices",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Distance Prices",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "location",
          label: "Location",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        location: "",
        amount: "",
      },
      deletePos: {
        location: "",
        id: "",
      },
      editPos: {
        location: "",
        amount: "",
        id: "",
      },
      existingLocation: [],
      locationError: "",
      amountError: "",
      modal: "",
    };
  },
   watch: {
      SaveStatus(newValue){
          if(newValue){
              this.resetAddModal();
              this.closeModal(this.modal);
          }
      },
  },
  computed: {
    ...mapGetters("transport", ["Distances", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Distances.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Distances.length;
  },
  methods: {
    ...mapActions({
      FetchDistances: "transport/fetchDistances",
      AddDistance: "transport/addDistance",
      EditDistance: "transport/editDistance",
      DeleteDistance: "transport/deleteDistance",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Distances.length;
      this.currentPage = 1;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    editCommas() {
      this.editPos.amount = this.thousandSeperater(this.editPos.amount);
    },

    resetError() {
      this.locationError = "";
      this.amountError = "";
    },

    resetAddModal() {
      this.data.location = "";
      this.data.amount = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingLocation = this.Distances.filter((ditance) => {
          return ditance.location.toUpperCase() == this.data.location.toUpperCase();
        });
        if (this.existingLocation.length) {
          this.locationError = this.data.location + " exists already";
        } else {
          this.locationError = "";
        }
      } else {
        this.existingLocation = [];
      }
    },
    addDistance(modal) {
      if (this.data.location == "") {
        this.locationError = "Location/Region field can't be empty";
        return;
      } else {
        this.locationError = "";
      }
      if (this.data.amount == "") {
        this.amountError = "Amount charged can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.existingLocation.length) {
        this.locationError = this.data.location + " exists already Please";
        return;
      } else {
        this.locationError = "";
      }
      this.modal = modal;
      this.AddDistance(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editPos.id = values.item.id;
      this.editPos.location = values.item.location;
      this.editPos.amount = values.item.amount;
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.location = values.item.location;
    },
    deleteDistance(modal) {
      this.modal = modal;
      this.DeleteDistance(this.deletePos);
      this.closeModal(modal);
    },
    editDistance(modal) {
      if (this.editPos.location == "") {
        this.locationError = "Location field can't be empty";
        return;
      } else {
        this.locationError = "";
      }
      if (this.editPos.amount == "") {
        this.amountError = "Amount field can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      this.modal = modal;
      this.EditDistance(this.editPos);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchDistances();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_position')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of Distance Prices</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-position-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_position')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Distances"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-position-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-position-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_position')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-position-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_position')
          )
        "
      >
        <template #modal-title> Add New Distance </template>
        <div class="form-group mb-3">
          <label>Location Name/Range/Region</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Location Name/Range/Region"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.location"
            />
          </div>
          <div class="text-danger" v-if="locationError">
            <em>{{ locationError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Amount Charged</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Amount Charged"
              class="form-control"
              @input="addCommas"
              v-model="data.amount"
            />
          </div>
          <div class="text-danger" v-if="locationError">
            <em>{{ locationError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addDistance('add-position-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-position-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Edit Distance {{ editPos.location }}</template>
        <div class="form-group mb-3">
          <label>Location/Region Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editPos.location"
            />
          </div>
          <div class="text-danger" v-if="locationError">
            <em>{{ locationError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Location/Region Charge</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError(),editCommas()"
              v-model="editPos.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editDistance('edit-position-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="delete-position-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Distance {{ deletePos.location }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Distance {{ deletePos.location }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteDistance('delete-position-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
